import { Feedback } from "@adoptaunabuelo/react-components";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router";
import { actionsCreators, State } from "../redux";
import Loading from "../components/modal/Loading";
import FelicitacionAuth from "../views/felicitacion/Auth";
import FelicitacionFlow from "../views/felicitacion/Flow";

const FelicitacionLayout = () => {
	const dispatch = useDispatch();
	const { setShowError } = bindActionCreators(actionsCreators, dispatch);
	const error = useSelector((state: State) => state.modals.error);
	const loading = useSelector((state: State) => state.modals.loading);

	return (
		<>
			<Loading isVisible={loading ? true : false} />
			<Feedback
				isVisible={error.show}
				type="error"
				text={error.message}
				onClose={() => setShowError({ show: false })}
			/>
			<Routes>
				<Route path="/" element={<FelicitacionFlow />} />
				<Route path="/registro" element={<FelicitacionAuth />} />
			</Routes>
		</>
	);
};

export default FelicitacionLayout;
